import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiError } from './lib/api';
import { applyThemePreference } from './lib/theme';
import { router } from './app/routes';
import { ToastProvider } from './ui/toast';
import './styles.css';

applyThemePreference();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx tekrar denenmez (yetki/doğrulama); ağ/5xx 2 kez.
      retry: (count, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && count < 2,
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
